import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const API_TOKEN = "d87204ea8a2dd4ffa7a59871288653bb242849ac";

// Thunk: Fetch AQI Data Based on City
export const fetchAQI = createAsyncThunk(
  "aqi/fetchAQI",
  async ({lat, lng}, { rejectWithValue }) => {
    try {
      const API_URL = `https://api.waqi.info/feed/geo:${lat};${lng}/?token=${API_TOKEN}`;
      const response = await fetch(API_URL);
      const data = await response.json();
      console.log(data);
      
      if (data.status !== "ok") {
        throw new Error("Failed to fetch AQI data");
      }

      return { aqi: data.data.aqi }; // Return city and AQI value
    } catch (error) {
      console.log(error);
      
      return rejectWithValue(error.message);
    }
  }
);

// export const fetchAQI = createAsyncThunk(
//   "aqi/fetchAQI",
//   async (city = "Pune", { rejectWithValue }) => {
//     try {
//       const API_URL = `https://api.waqi.info/feed/${city}/?token=${API_TOKEN}`;
//       const response = await fetch(API_URL);
//       const data = await response.json();
//       console.log(data);
      
//       if (data.status !== "ok") {
//         throw new Error("Failed to fetch AQI data");
//       }

//       return { city, aqi: data.data.aqi }; // Return city and AQI value
//     } catch (error) {
//       console.log(error);
      
//       return rejectWithValue(error.message);
//     }
//   }
// );

const aqiSlice = createSlice({
  name: "aqi",
  initialState: {
    city: "Pune",
    aqi: null,
    loading: false,
    error: null,
  },
  reducers: {}, // No additional reducers needed
  extraReducers: (builder) => {
    builder
      .addCase(fetchAQI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAQI.fulfilled, (state, action) => {
        state.loading = false;
        state.city = action.payload.city;
        state.aqi = action.payload.aqi;
      })
      .addCase(fetchAQI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default aqiSlice.reducer;
